import type { Product } from "@towni/common";
import { createContext, useContext } from "react";

const ProductContext = createContext<Product | undefined>(undefined);
const ProductContextProvider = (props: {
    product: Product;
    children: React.ReactNode;
}) => {
    return (
        <ProductContext.Provider value={props.product}>
            {props.children}
        </ProductContext.Provider>
    );
};

function useProductFromContext(): Product;
function useProductFromContext(options: {
    doNotThrow: true;
}): Product | undefined;
function useProductFromContext(options?: {
    doNotThrow?: boolean;
}): Product | undefined {
    const product = useContext(ProductContext);
    if (typeof product === "undefined" && options?.doNotThrow) return undefined;
    if (typeof product === "undefined") {
        throw new Error(
            "useProductFromContext must be used within a ProductContextProvider",
        );
    }
    return product;
}

export { ProductContext, ProductContextProvider, useProductFromContext };
